// Policy status values as defined by the policy-admin-complex service.
// Mirrors the PolicyDetailsDTO.status enum in the service's OpenAPI spec
// (https://policy-admin-complex.staging.aspin-inclusivity.com/docs-json).
// The backend exposes no endpoint listing these, so this constant is the
// single client-side source for policy status options.
export const POLICY_STATUSES = [
         'Cancelled',
         'Unpaid',
         'Un_Confirmed',
         'Rejected',
         'Full_Coverage',
         'In_Arrears',
         'Non_Payment',
         'Not_Taken_Up',
         'Discarded',
         'Expired',
         'Pending'
       ]

export function formatPolicyStatusLabel(status) {
  return (status || '').split('_').join(' ')
}
